export const PostPurchasePromoDesignPhase2AbTestVariantBasicTemplate = '0';
export const PostPurchasePromoDesignPhase2AbTestVariant3StepTemplate = '1';
export const PostPurchasePromoDesignPhase2AbTestVariantVideoTemplate = '2';
